import React, { useContext } from "react";
import { useParams } from "react-router-dom";

import SidepanelHeader from "./ui/sidepanel-header";
import LoadingIcon from "../../Loaders/LoadingIcon";
import { formatAddress } from "../../../pages/Admin/Routes/RoutePage/Routes/utils";
import format from "date-fns/format";
import { ActiveRouteDataContext } from "./ActiveRouteDataLayer";
import useNavigateKeepSearchParams from "../../../hooks/useNavigateKeepSearchParams";

const ActiveRoutesRoutePropertyDetail = () => {
  const { activeRoutesQuery, activeRoutes } = useContext(
    ActiveRouteDataContext,
  );
  let baseUrl = window.location.pathname.match(/(.*active-routes)\//)[1];
  let { routeId, propertyId } = useParams();
  let navigate = useNavigateKeepSearchParams(["app_version"]);

  const loading = activeRoutesQuery.isLoading;

  if (loading) return <LoadingIcon />;

  let data = activeRoutes.find((route) => route._id == routeId);
  if (!data) {
    return <p className="pt-2 text-base">No route was found</p>;
  }

  let property = data.route?.jobs.find(
    (property) => property._id === propertyId,
  );
  if (!property) {
    return <p className="pt-2 text-base">No property was found</p>;
  }

  const lastServicedDate =
    property.jobHistories && property.jobHistories.length > 0
      ? new Date(
          property.jobHistories[property.jobHistories.length - 1].endTimeUTC,
        )
      : "";

  return (
    <>
      <div className="px-5 pb-4 border-b border-gray-200">
        <div className="flex items-end justify-between">
          <SidepanelHeader
            onClose={(e) => {
              e.preventDefault();
              navigate(`${baseUrl}/main/${data._id}`);
            }}
          >
            {property.name}
          </SidepanelHeader>
        </div>
      </div>
      <div className="px-6 py-4 pb-4">
        <p className="text-sm">{formatAddress(property.address)}</p>
        {property.jobHistories?.length > 0 ? (
          <>
            <h3 className="mt-6 mb-2 text-gray-600 font-bold">
              Services performed
            </h3>
            {property.jobHistories.map((history, index) => (
              <>
                <ul key={index} className="pb-2 text-base">
                  {history.servicesPerformed
                    .filter((service) => service.checked)
                    .map((service, key) => (
                      <li key={key}>
                        {service.label}
                        {service.options ? (
                          <>
                            <ul
                              role="list"
                              className="pl-5 pt-2 pb-3 space-y-1 list-disc marker:text-sky-800"
                            >
                              {service.options
                                // .filter((option) => option.checked)
                                .map((option, key) => (
                                  <li key={key}>{option.label}</li>
                                ))}
                            </ul>
                          </>
                        ) : null}
                      </li>
                    ))}
                </ul>
              </>
            ))}
          </>
        ) : null}
        {lastServicedDate ? (
          <p className="pt-2 text-sm text-gray-500">
            Last serviced:{" "}
            {property.status === "current"
              ? "In Progress"
              : format(lastServicedDate, "MMM d, yyyy h:mm bbb")}
          </p>
        ) : null}
      </div>
    </>
  );
};

export default ActiveRoutesRoutePropertyDetail;
